export const STOCK_TABLE = "stocks"
export const STOCK_TABLE_SCHEMA =
  "id, companyId, productId, partnerId, lotId, locationId, syncId, [companyId+productId]"
